import { Injectable } from '@angular/core';
import {
    HammerGestureConfig,
} from '@angular/platform-browser';

// To enable scroll in carousel component
// https://github.com/angular/angular/issues/10541#issuecomment-271083162
@Injectable()
export class EnableScrollHammerConfig extends HammerGestureConfig {
    overrides = {
        pinch: { enable: false },
        rotate: { enable: false },
    };
}
